<template>
    <div>
        <br>
        <p class="jbrowse-genome">JBrowse({{genome}})</p>
        <iframe ref="iframe" id="bdIframe" :src="getUrl()" frameborder="0" scrolling="yes"></iframe>
    </div>
</template>

<script>
    export default {
        name: "SearchJBrowse",
        data() {
            return {
                genome:this.$route.query.Genome,
                chromosome:this.$route.query.Chromosome,
                startPos:this.$route.query.StartPos,
                endPos:this.$route.query.EndPos,
            }
        },
        // created() {
        //     this.getUrl();
        // },
        mounted(){
            /**
             * iframe-宽高自适应显示
             */
            const oIframe = document.getElementById('bdIframe');
            // const deviceWidth = document.documentElement.clientWidth;
            const deviceHeight = document.documentElement.clientHeight;
            oIframe.style.width = 1155 + 'px'; //数字是页面布局宽度差值
            oIframe.style.height = (Number(deviceHeight)) + 'px'; //数字是页面布局高度差
        },
        methods: {
            /**
             * 获取-外部接口信息
             */
            // getUrl() {
            //     let that = this
            //     let bdUrl = {queryurl: this.$paths.bdpath+'/locate'};
            //     this.$api.getBdToken(bdUrl,function(res) {
            //         that.bdTokenUrl = res.data.data;
            //     })
            // },
            getUrl() {
                let genome = this.genome
                let chromosome = this.chromosome
                let startPos = this.startPos
                let endPos = this.endPos
                // console.log(genome)
                if(chromosome) {
                    // var url = 'http://39.100.233.196/jbrowse/?data=' + genome + '&loc=' + chromosome + '%3A' + startPos + '..' + endPos
                    var url = 'http://39.100.233.196:83/jbrowse/?data=' + genome + '&loc=' + chromosome + '%3A' +
                    startPos + '..' + endPos + '&tracks=DNA%2C' + genome + '&highlight='
                    // console.log(url)
                    return url;
                }
                else {
                    var url = 'http://39.100.233.196:83/jbrowse?data=' + genome  // eslint-disable-line
                    // console.log(url)
                    return url;
                }
            }
        }
    }
</script>

<style>
    #bdIframe {
        margin: 30px 22px 30px 22px;
    }

    .jbrowse-genome {
        text-align: center;
        font-size: larger;
        color: #407338;
    }
</style>